export default "__VITE_ASSET__8d6f6c53__"